import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14 0h-1.003L0 12.833V14h.976L14 .976V0ZM9.038 0 0 8.944v1.945L11.017 0h-1.98ZM5.087.031 0 5.021V7l7-7-1.913.031ZM1.116 0 0 1.167V3.11L3.096 0h-1.98ZM14 2.956 2.956 14.001h1.979L14 4.934V2.956ZM14 6.919 6.918 14h1.98L14 8.898V6.92ZM14 10.878 10.877 14h1.98L14 12.857v-1.98Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent
